var map = {
	"./chess-icon.png": 95469,
	"./egame-icon.png": 20609,
	"./fishing-icon.png": 10845,
	"./gaming-icon.png": 27741,
	"./lottery-icon.png": 6749,
	"./realbet-icon.png": 33757,
	"./sport-icon.png": 35103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76700;